import { createSlice } from '@reduxjs/toolkit';
import { loginApi } from "../../api/auth/loginApi";

export const loginSlice = createSlice({
    name: 'account/login',
    initialState: {
        request: false,
        message: '',
        outcome: 'pending',
    },
    reducers: {
        cancelError(state) {
            state.request = false;
            state.outcome = 'pending';
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginApi.pending, (state, action) => {
                state.request = true;
            })
            .addCase(loginApi.fulfilled, (state, action) => {
                state.request = false;
                state.outcome = 'success';
                state.message = '';
            })
            .addCase(loginApi.rejected, (state, action) => {
                const { payload } = action;
                state.request = false;
                state.outcome = 'fail';
                //@ts-ignore
                state.message = payload.message;
            })
    },
});

export const { cancelError } = loginSlice.actions

export default loginSlice.reducer;